import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MaterialApoyoDetallePage } from './material-apoyo-detalle';
import { ComponentsModule } from '../../components/components.module';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    MaterialApoyoDetallePage,
  ],
  imports: [
    IonicPageModule.forChild(MaterialApoyoDetallePage),
    ComponentsModule,
    DirectivesModule
  ]
})
export class MaterialApoyoDetallePageModule {}



// WEBPACK FOOTER //
// ./src/pages/material-apoyo-detalle/material-apoyo-detalle.module.ts